import playerSize from './player-size';
import playerColor from './player-color';

export default [playerSize, playerColor];
